// Génération de textes par IA (bio, posts, press-book, optimiseur de profil).
// Désactivée pour alléger le serveur. Pour la remettre : passer à true ici et
// définir AI_GENERATION_ENABLED=1 côté backend (voir backend/routers/ai.py).
export const AI_GENERATION_ENABLED = false;
